import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

interface UpdateEventDetailProps {
  locationId: string;
  eventId: string;
  description: string;
  posterDataUrls: string[];
}

export const updateEventDetail = async ({
  locationId,
  eventId,
  description,
  posterDataUrls
}: UpdateEventDetailProps) => {
  const response = await fetch(`${baseUrl()}/api/v1/locations/${locationId}/events/${eventId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      event: {
        description,
        poster_data_urls: posterDataUrls
      }
    })
  });

  return response;
};
